module.exports = __webpack_public_path__ + "media/icons/template-4286ca9d.svg";